<!-- Summary KPIs for the selected period / fixed 12-month report (shared prototype `.cijfer`). -->
<template>
    <section class="summary-grid">
        <article class="cijfer">
            <span class="label"><font-awesome-icon icon="fa-solid fa-calendar" />Total Bookings</span>
            <span class="waarde">{{ formatInt(summary.totalBookings) }}</span>
            <span v-if="comparison" class="verschil" :class="changeKindClass(comparison.bookings)">{{ changeText(comparison.bookings, comparison.label) }}</span>
        </article>
        <article class="cijfer">
            <span class="label"><font-awesome-icon icon="fa-solid fa-users" />Total Players</span>
            <span class="waarde">{{ formatInt(summary.totalPlayers) }}</span>
            <span v-if="comparison" class="verschil" :class="changeKindClass(comparison.players)">{{ changeText(comparison.players, comparison.label) }}</span>
        </article>
        <article class="cijfer">
            <span class="label"><font-awesome-icon icon="fa-solid fa-users" />Avg Players/Booking</span>
            <span class="waarde">{{ summary.avgPlayersPerBooking.toFixed(1) }}</span>
            <span v-if="comparison" class="verschil" :class="changeKindClass(comparison.avgPlayersPerBooking)">{{ changeText(comparison.avgPlayersPerBooking, comparison.label) }}</span>
        </article>
        <article v-if="summary.hasLocationRating" class="cijfer">
            <span class="label"><font-awesome-icon icon="fa-solid fa-star" />{{ summary.ratingLabel || "Avg Location Rating" }}</span>
            <span class="waarde">{{ summary.avgLocationRating.toFixed(1) }}<small>/ 5</small></span>
        </article>
    </section>
</template>

<script setup>
import { changeKindClass, changeText } from "../../helpers/dashboardAggregations";

defineProps({
    summary: {
        type: Object,
        required: true,
    },
    comparison: {
        type: Object,
        default: null,
    },
});

function formatInt(value) {
    return Number(value || 0).toLocaleString();
}
</script>

<style scoped lang="scss">
/* Only the responsive grid is local; card chrome and delta colors are shared (`.cijfer`, `.verschil`). */
.summary-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 190px), 1fr));
    gap: var(--s-3);
}
</style>
